export const WebShare = {
  mounted() {
    this.handleWebShare();
  },

  updated() {
    this.handleWebShare();
  },

  handleWebShare() {
    const canShare = navigator.share && this.canShareData();

    if (!canShare) {
      // Hide the share button if Web Share API is not supported
      this.el.style.display = 'none';
      return;
    }

    // Show the button and set up the icon based on platform
    this.el.style.display = '';
    this.updateShareIcon();

    // Set up click handler
    this.el.addEventListener('click', this.handleShare.bind(this));
  },

  canShareData() {
    const url = this.el.dataset.url;
    const title = this.el.dataset.title;

    if (!url && !title) return false;

    const shareData = {};
    if (title) shareData.title = title;
    if (url) shareData.url = url;

    return navigator.canShare ? navigator.canShare(shareData) : true;
  },

  updateShareIcon() {
    const iconElement = this.el.querySelector('svg');
    console.log(iconElement);
    if (!iconElement) return;

    const platform = this.detectPlatform();

    if (platform === 'ios' || platform === 'macos') {
      // iOS/macOS share icon (square with arrow pointing up)
      iconElement.innerHTML = `
        <path
          d="M8.25 10.875V19.125C8.25 19.4016 8.35975 19.6669 8.55546 19.8626C8.75117 20.0583 9.01641 20.1681 9.29297 20.1681H18.7070C18.9836 20.1681 19.2488 20.0583 19.4445 19.8626C19.6402 19.6669 19.75 19.4016 19.75 19.125V10.875"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M14 3.75L14 15.75"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M10.5 7.25L14 3.75L17.5 7.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
      `;
    } else if (platform === 'android') {
      // Android share icon (three connected dots)
      iconElement.innerHTML = `
        <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.935-2.186 2.25 2.25 0 00-3.935 2.186z"/>
      `;
    } else {
      // leave icon unchaged for other platforms
    }
  },

  detectPlatform() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'ios';
    } else if (/macintosh|mac os x/.test(userAgent)) {
      return 'macos';
    } else if (/android/.test(userAgent)) {
      return 'android';
    } else {
      // leve icon unchaged for other platforms
      return null;
    }
  },

  async handleShare(event) {
    event.preventDefault();

    const url = this.el.dataset.url;
    const title = this.el.dataset.title;

    if (!url && !title) return;

    const shareData = {};
    if (title) shareData.title = title;
    if (url) shareData.url = url;

    try {
      await navigator.share(shareData);
    } catch (error) {
      // Handle share cancellation or errors silently
      if (error.name !== 'AbortError') {
        console.warn('Web Share API error:', error);
      }
    }
  }
};
